import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';

@Component({
    selector: 'app-menu-side-actions-msg',
    templateUrl: './menu-side-actions-msg.component.html',
    styleUrls: ['./menu-side-actions-msg.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideActionsMsgComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData
    > = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    constructor() {}

    ngOnInit(): void {}
}
